import "./style.css";
import React, { useState, useEffect, useContext } from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import Logo from "../../../resources/logo.png";
import { CartContext } from "../../../context/CartContext";
import { host } from "../../../config/Config";
import EducationBreadcrumb from "../../../common/EducationBreadcrumb";

export const BeginnerEducation = () => {
    const phoneNumber = "+381 60-3859-426";
    const { addToCart } = useContext(CartContext);
    const [nineWeekPrice, setNineWeekPrice] = useState(0);
    const [twelveWeekPrice, setTwelveWeekPrice] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);

        // Fetch prices for both programs
        Promise.all([
            fetch(`${host}/api/v1/education-prices/type/nine-week`),
            fetch(`${host}/api/v1/education-prices/type/twelve-week`),
        ])
            .then(([nineWeekRes, twelveWeekRes]) =>
                Promise.all([nineWeekRes.json(), twelveWeekRes.json()])
            )
            .then(([nineWeekData, twelveWeekData]) => {
                setNineWeekPrice(nineWeekData.price);
                setTwelveWeekPrice(twelveWeekData.price);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching prices:", error);
                setNineWeekPrice(500);
                setTwelveWeekPrice(700);
                setLoading(false);
            });
    }, []);

    const HandleOpenMap = () => {
        const url = `https://maps.app.goo.gl/6wxPp2i9rRZ45HQs6`;
        window.open(url, "_blank");
    };

    const handleAddToCart = (duration, price) => {
        addToCart({
            id: duration === 9 ? "nine-week" : "twelve-week",
            name:
                duration === 9
                    ? "Početničke edukacije - 9 Nedelja"
                    : "Početničke edukacije - 12 Nedelja",
            price: price,
            category: "beginner",
            duration: duration,
        });
    };

    return (
        <div className='page-beginner'>
            <EducationBreadcrumb />

            <div className='items-beginner'>
                <h1
                    style={{
                        fontSize: "37px",
                        color: "#be9455",
                        letterSpacing: "1px",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    Početničke Edukacije
                </h1>
                <h1 style={{ marginTop: "-19px" }}>9 ili 12 nedelja</h1>
                <p>
                    Naš program edukacije za početnike pruža kompletnu obuku za
                    sve koji žele da započnu karijeru u barberingu ili unaprede
                    postojeće osnovne veštine.
                </p>

                <p
                    style={{
                        textAlign: "center",
                        fontSize: "28px",
                        color: "#be9455",
                        letterSpacing: "1px",
                        marginTop: "30px",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    Nedelja 1-4
                </p>
                <p
                    style={{
                        textAlign: "center",
                        fontSize: "24px",
                        color: "#be9455",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    Osnove i Fundamenti
                </p>
                <p style={{ textAlign: "center" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Naučićete osnovne tehnike šišanja - jednu dužinu, slojeve i
                    gradaciju - na modelima sa dužom kosom
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Prolazimo sve uglove sečenja (horizontalne, vertikalne,
                    dijagonalne) i upoznajemo vas sa pravilnim držanjem,
                    položajem ruku i metodama šema
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Takođe ćete početi da učite tehnike brijanja, od osnovnih
                    metoda za početnike do naprednijih koji koriste iskusniji
                    profesionalci
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Nezi brade se pristupa sistematski, obuhvatajući duge brade,
                    kratke brade i često zanemareno oblikovanje brkova
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Ovu fazu završavamo klasičnim prečicama i osnovama fade i
                    taper tehnika - sve uz naglasak na vlastitom držanju, govoru
                    tela i profesionalnom pristupu klijentima
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Kada je teorija završena, prelazimo na stvarne modele
                </p>

                <img
                    src={Logo}
                    style={{
                        width: "140px",
                        borderRadius: "8px",
                        marginTop: "20px",
                    }}
                />

                <p
                    style={{
                        textAlign: "center",
                        fontSize: "28px",
                        color: "#be9455",
                        letterSpacing: "1px",
                        marginTop: "30px",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    Nedelja 4-9
                </p>
                <p
                    style={{
                        textAlign: "center",
                        fontSize: "24px",
                        color: "#be9455",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    Savladavanje kroz vežbanje
                </p>
                <p style={{ textAlign: "center" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Narednih šest nedelja je posvećeno vežbanju, ponavljanju i
                    usavršavanju
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Izgradićete brzinu, preciznost i samopouzdanje, radeći na
                    modelima svakodnevno
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Takođe, predstavljamo kreativnije i složenije tehnike
                    šišanja i pozivamo inspirativne gostujuće berbere da podele
                    svoje stručno znanje i dalje unaprede vašu viziju
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Tokom celog programa, nikada niste sami, mi vas podržavamo
                    na svakom koraku
                </p>

                <p
                    style={{
                        textAlign: "center",
                        fontSize: "28px",
                        color: "#be9455",
                        letterSpacing: "1px",
                        marginTop: "30px",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    Nedelja 9-12
                </p>
                <p
                    style={{
                        textAlign: "center",
                        fontSize: "24px",
                        color: "#be9455",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    Napredno proširenje (opciono)
                </p>
                <p style={{ textAlign: "center" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Za one koji žele da idu dalje od osnovnog nastavnog plana i
                    programa nudimo opcionu nadogradnju od 3 nedelje
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Naprednim prelazima, efekti i teksture
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Precizno sečenje i visokokvalitetna kontrola mašina za
                    šišanje
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Dizajniranje uređeničkog i kreativnog izgleda
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Napredne tehnike oblikovanja brade
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Razvoj portfolija i iskustvo u vlastitom salonu
                </p>

                <img
                    src={Logo}
                    style={{
                        width: "140px",
                        borderRadius: "8px",
                        marginTop: "20px",
                    }}
                />

                <p
                    style={{
                        fontSize: "22px",
                        marginTop: "30px",
                        textAlign: "center",
                    }}
                >
                    Možete početi sa 9-nedeljnom osnovnom edukacijom ili
                    odabrati prošireni 12-nedeljni program sa naprednim
                    tehnikama. Datum početka birate u narednom koraku.
                </p>

                {/* Two separate add to cart sections */}
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "30px",
                        marginTop: "30px",
                    }}
                >
                    {/* 9 Week Program */}
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "15px",
                        }}
                    >
                        <h2
                            style={{
                                color: "#be9455",
                                textShadow:
                                    "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                            }}
                        >
                            Osnovna edukacija - 9 nedelja
                        </h2>
                        {!loading && (
                            <div
                                style={{
                                    textAlign: "center",
                                    fontSize: "32px",
                                    fontWeight: "bold",
                                    color: "#be9455",
                                    textShadow:
                                        "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                                }}
                            >
                                Cena: {nineWeekPrice.toLocaleString()} EUR
                            </div>
                        )}
                        <div
                            className='buy-button-beginner'
                            onClick={() => handleAddToCart(9, nineWeekPrice)}
                        >
                            <p>Dodaj u korpu</p>
                        </div>
                    </div>

                    {/* 12 Week Program */}
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "15px",
                        }}
                    >
                        <h2
                            style={{
                                color: "#be9455",
                                textShadow:
                                    "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                            }}
                        >
                            Proširena edukacija - 12 nedelja
                        </h2>
                        {!loading && (
                            <div
                                style={{
                                    textAlign: "center",
                                    fontSize: "32px",
                                    fontWeight: "bold",
                                    color: "#be9455",
                                    textShadow:
                                        "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                                }}
                            >
                                Cena: {twelveWeekPrice.toLocaleString()} EUR
                            </div>
                        )}
                        <div
                            className='buy-button-beginner'
                            onClick={() => handleAddToCart(12, twelveWeekPrice)}
                        >
                            <p>Dodaj u korpu</p>
                        </div>
                    </div>
                </div>
            </div>

            <a
                className='barbershop-zajednica-footer-title-adresa'
                onClick={HandleOpenMap}
                target='_blank'
                rel='noopener noreferrer'
            >
                <div>
                    <h2>Srpskog sovjeta 1a</h2>
                    <h2>11300, Smederevo</h2>
                    <h2> Klikni me</h2>
                </div>
            </a>
            <div className='barbershop-zajednica-footer-title-adresa'>
                <h2>Posetite Instagram</h2>
                <a
                    href='https://www.instagram.com/_zajednica_/'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{
                        marginTop: "10px",
                        width: "100%",
                        justifyContent: "center",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        color: "#f3f3f3",
                        textDecoration: "none",
                    }}
                >
                    <InstagramIcon
                        style={{ color: "#f3f3f3", fontSize: "40px" }}
                    />
                </a>
            </div>

            <div className='barbershop-zajednica-footer-title'>
                <h2>Ili nas kontaktirajte</h2>
            </div>
            <div className='barbershop-zajednica-footer-phone'>
                <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
            </div>
        </div>
    );
};
